export default __webpack_public_path__ + "static/media/pl.f2481946.svg";